import { BitrixVue } from 'ui.vue';
import { DropArea } from './drop-area';
import { TileList } from './tile-list';
import { Stack } from './stack';
import { Text } from 'main.core';
import { Popup } from 'main.popup';
import { MountingPortal } from 'ui.vue.portal';
import { CloseButton } from 'ui.buttons';

export const TileUploaderComponent = BitrixVue.localComponent('tile-uploader', {
	props: {
		error: {
			type: Object,
		},
		stackMode: {
			type: Boolean,
			default: false,
		},
		items: {
			type: Array,
			default: [],
		}
	},
	data() {
		return {
			popup: null,
			popupContentId: '',
		}
	},
	components:
	{
		DropArea,
		TileList,
		Stack,
		MountingPortal,
	},
	methods: {
		showPopup()
		{
			if (!this.popup)
			{
				const id = 'stack-uploader-' + Text.getRandom().toLowerCase();
				const popup = new Popup({
					width: 750,
					height: 400,
					draggable: true,
					titleBar: 'Uploaded Files',
					content: `<div id="${id}"></div>`,
					cacheable: false,
					closeIcon: true,
					closeByEsc: true,
					events: {
						onDestroy: () => this.popup = null,
					},
					buttons: [
						new CloseButton({ onclick: () => this.popup.close() }),
					]
				});

				this.popupContentId = `#${id}`;
				this.popup = popup;
			}

			this.popup.show();
		}
	},
	watch:
	{
		error()
		{
			alert(this.error.message);
		}
	},
	// language=Vue
	template: `
		<div class="ui-tile-uploader">
			{{ error && error.message ? error.message : 'none' }}
			<template v-if="stackMode">
				<Stack v-on:click="showPopup"/>
				<mounting-portal v-if="popup" :mount-to="popupContentId" append>
					<TileList :items="items"></TileList>
				</mounting-portal>
			</template>
			<template v-else>
				<template v-if="items.length === 0">
					<DropArea />
				</template>
				<template v-else>
					<TileList :items="items"></TileList>
					<DropArea />
				</template>
			</template>
		</div>
	`
});
